import { useState } from "react";
import { num } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const when = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" }) : "–");

export const LogisticsOrders = ({ orders, total }) => {
  const [q, setQ] = useState("");
  const s = q.trim().toLowerCase();
  const rows = s ? orders.filter((o) => `${o.order_number} ${o.packer} ${o.customer_name}`.toLowerCase().includes(s)) : orders;
  return (
    <Card className="p-6" data-testid="logistics-orders">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h3 className="font-display text-lg font-semibold">Ordini preparati</h3>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca ordine, dipendente o cliente" className="max-w-xs" data-testid="logistics-search" />
      </div>
      <div className="max-h-[420px] overflow-auto">
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent"><TableHead>Ordine</TableHead><TableHead>Cliente</TableHead><TableHead>Preparato da</TableHead><TableHead>Controllato</TableHead><TableHead className="text-right">Capi</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((o) => (
              <TableRow key={`${o.order_number}-${o.checked_at}`} data-testid={`logistics-order-${o.order_number}`}>
                <TableCell className="font-mono-erp text-xs">{o.order_number}</TableCell>
                <TableCell className="text-sm">{o.customer_name}</TableCell>
                <TableCell className="text-sm font-medium">{o.packer}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{when(o.checked_at)}{!o.scanned && " (evasione)"}{o.exchange && <span className="ml-2 rounded border border-sky-500/50 px-1.5 py-0.5 text-[10px] text-sky-400">Cambio/reso</span>}</TableCell>
                <TableCell className="text-right text-sm">{num(o.pieces)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {total > orders.length && <p className="mt-2 text-xs text-muted-foreground">Mostrati gli ultimi {num(orders.length)} di {num(total)}.</p>}
    </Card>
  );
};
